export const ACCOUNT_PROFILE_VERSION =
  "2026-09-account-pages-v4";

export const accountSections = [
  {
    key: "profile",
    title: "Thông tin cá nhân",
    description: "Hồ sơ và thông tin tài khoản",
    group: "account",
    path: "/tai-khoan/thong-tin-ca-nhan"
  },
  {
    key: "orders",
    title: "Đơn hàng của tôi",
    description: "Lịch sử và trạng thái đơn hàng",
    group: "account",
    path: "/tai-khoan/don-hang"
  },
  {
    key: "books",
    title: "Sách của tôi",
    description: "Thư viện sách và tài liệu",
    group: "account",
    path: "/sach-cua-toi"
  },
  {
    key: "addresses",
    title: "Địa chỉ nhận hàng",
    description: "Quản lý địa chỉ giao hàng",
    group: "account",
    path: "/tai-khoan/dia-chi"
  },
  {
    key: "vouchers",
    title: "Voucher",
    description: "Mã giảm giá hiện có",
    group: "account",
    path: "/tai-khoan/voucher"
  },
  {
    key: "notifications",
    title: "Thông báo",
    description: "Thông tin và cập nhật mới",
    group: "account",
    path: "/tai-khoan/thong-bao"
  },

  {
    key: "blog",
    title: "Blog",
    description: "Kiến thức và bài viết y khoa",
    group: "discover",
    path: "/blog"
  },
  {
    key: "utilities",
    title: "Tiện ích",
    description: "Công cụ sức khỏe và y khoa",
    group: "discover",
    path: "/tienich"
  },

  {
    key: "password",
    title: "Đổi mật khẩu",
    description: "Thay đổi mật khẩu đăng nhập",
    group: "security",
    path: "/tai-khoan/doi-mat-khau"
  },
  {
    key: "devices",
    title: "Thiết bị đăng nhập",
    description: "Quản lý thiết bị Books OS",
    group: "security",
    path: "/tai-khoan/thiet-bi"
  },

  {
    key: "privacy",
    title: "Chính sách bảo mật & Quyền riêng tư",
    description: "Bảo mật và dữ liệu cá nhân",
    group: "legal",
    path: "/tai-khoan/chinh-sach-bao-mat"
  },
  {
    key: "copyright",
    title: "Bản quyền & tài liệu PDF",
    description: "Thông tin sở hữu trí tuệ",
    group: "legal",
    path: "/tai-khoan/ban-quyen"
  },

  {
    key: "support",
    title: "Trung tâm trợ giúp",
    description: "Liên hệ hỗ trợ qua Messenger",
    group: "support",
    url: "https://m.me/cuahangykhoacom?ref=tukhoa"
  },

  {
    key: "logout",
    title: "Đăng xuất",
    description: "Thoát khỏi tài khoản",
    group: "logout",
    action: "logout"
  }
];

export const getAccountSection =
  key => accountSections.find(
    item => item.key === key
  );
